import { addBackToTop, DEFAULT_SETTINGS } from '../../src/components/back_to_top/back_to_top';
import React from 'react';
import ReactDOM from 'react-dom';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';
import DataGatheringBannerBootstrap5 from '../../src/components/react/data_gathering_banner/bootstrap_5/data_gathering_banner_bootstrap_5';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('career-account-data-gathering');
  if (root) {
    ReactDOM.render(
      <DevexHighOrderComponent>
        <DataGatheringBannerBootstrap5 requestedField={root.dataset.requestedField} />
      </DevexHighOrderComponent>,
      root
    );
  }

  addBackToTop(DEFAULT_SETTINGS);
});
